import _ from "lodash-es";

import { fixDateFromDataBase } from "../../tools/formatDate";

const ChartsDataCompute = (props, edges) => {
  // console.log("===> Compute", props);
  const { intl } = props;

  if (edges) {
    let mapPeriode = new Map();
    let mapPeriodeNegative = new Map();

    var typePeriode = props.currentPeriod;
    var currentYear = props.currentYear;

    let previousYearStr = (props.currentYear - 1).toString();
    let currentYearStr = props.currentYear.toString();

    // filter
    let filterPeriod = props.selectedPeriod + 1;
    //console.log(">>>", filterPeriod);

    filterPeriod = ("0" + filterPeriod).slice(-2);
    //console.log(">>>", filterPeriod);

    if (props.currentPeriod === "Q")
      filterPeriod = "Q" + (props.selectedPeriod + 1);
    // filter
    if (props.currentPeriod === "S")
      filterPeriod = "S" + (props.selectedPeriod + 1);

    if (props.currentPeriod === "N")
      filterPeriod = "N" + (props.selectedPeriod + 1);

    let data = [];
    for (let j = 0, lenj = edges.length; j < lenj; j++) {
      //console.log("#" + j + " -", edges[j].node);

      let tmpDate = new Date(fixDateFromDataBase(edges[j].node.dateOperation));
      let key = "";
      // let keyYear = tmpDate.getFullYear().toString();
      let key2 = "";

      switch (typePeriode) {
        case "Q":
          key = tmpDate.getFullYear().toString() + "-";
          switch (tmpDate.getMonth() + 1) {
            case 1:
            case 2:
            case 3:
              key = key + "Q1";
              key2 = "Q1";
              break;

            case 4:
            case 5:
            case 6:
              key = key + "Q2";
              key2 = "Q2";
              break;

            case 7:
            case 8:
            case 9:
              key = key + "Q3";
              key2 = "Q3";
              break;

            case 10:
            case 11:
            case 12:
              key = key + "Q4";
              key2 = "Q4";
              break;

            default:
              break;
          }
          break;

        case "S":
          key = tmpDate.getFullYear().toString() + "-";
          switch (tmpDate.getMonth() + 1) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
              key = key + "S1";
              key2 = "S1";
              break;

            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
              key = key + "S2";
              key2 = "S2";
              break;

            default:
              break;
          }
          break;

        case "N":
          key = tmpDate.getFullYear().toString() + "-";
          switch (tmpDate.getMonth() + 1) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
              key = key + "N1";
              key2 = "N1";
              break;

            case 10:
            case 11:
            case 12:
              key = key + "N2";
              key2 = "N2";
              break;

            default:
              break;
          }
          break;

        case "Y":
          key = tmpDate.getFullYear().toString();
          key2 = "Y";
          break;

        case "M":
        default:
          key =
            tmpDate.getFullYear().toString() +
            "-" +
            ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);

          key2 = ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);
          break;
      }



      // Periode
      let tmpValue;
      let tmpCount;
      let negateValues = props.negateValues;

      if (
        props.splitAmountsByCategory &&
        edges[j].node.category.categoryFamily.reportCost
      ) {
        //negateValues = !negateValues;
        tmpValue = mapPeriodeNegative.get(key) && mapPeriodeNegative.get(key).value;
        tmpCount = mapPeriodeNegative.get(key) && mapPeriodeNegative.get(key).count;
      } else {
        tmpValue = mapPeriode.get(key) && mapPeriode.get(key).value;
        tmpCount = mapPeriode.get(key) && mapPeriode.get(key).count;
      }

      if (tmpValue === undefined) {
        tmpValue = 0.0;
        tmpCount = 0;
      }

      const amount = edges[j].node.amount;

      tmpValue = _.round(tmpValue + (negateValues ? amount * -1 : amount), 2);
      tmpCount++;

      if (
        props.splitAmountsByCategory &&
        edges[j].node.category.categoryFamily.reportCost
      )
        mapPeriodeNegative.set(key, { value: tmpValue, count: tmpCount });
      else
        mapPeriode.set(key, { value: tmpValue, count: tmpCount });

      //console.log("node", edges[j].node.category.categoryFamily.name);
      /*
      if (props.type === "cost") {
        // Periode + Categorie
        let tmpPair = {};

        let tmpMapCategory = mapPeriodeCategory.get(key2);
        if (tmpMapCategory !== undefined) {
          tmpPair = tmpMapCategory.get(edges[j].node.category.name);
          if (
            tmpPair !== undefined &&
            tmpPair.mapCategoryPerYear !== undefined
          ) {
            tmpValue = tmpPair.mapCategoryPerYear.get(keyYear);

            if (tmpValue === undefined) tmpValue = 0.0;
          } else {
            tmpPair = {};
            tmpPair.family = edges[j].node.category.categoryFamily.name;
            tmpPair.mapCategoryPerYear = new Map();
            tmpValue = 0.0;
          }
        } else {
          tmpPair = {};
          tmpPair.family = edges[j].node.category.categoryFamily.name;
          tmpPair.mapCategoryPerYear = new Map();
          tmpMapCategory = new Map();
          tmpValue = 0.0;
        }

        tmpValue = _.round(
          tmpValue + (props.negateValues ? amount * -1 : amount),
          2
        );

        tmpPair.mapCategoryPerYear.set(keyYear, tmpValue);
        tmpMapCategory.set(edges[j].node.category.name, tmpPair);

        mapPeriodeCategory.set(key2, tmpMapCategory);
      }
      */

      // build table data item

      if (filterPeriod === key2 || typePeriode === "Y") {
        const amount = props.negateValues
          ? -edges[j].node.amount
          : edges[j].node.amount;

        let year = tmpDate.getFullYear().toString();
        const currentYearAmount = currentYearStr === year ? amount : 0;
        const previousYearAmount = previousYearStr === year ? amount : 0;
        const amountVariation = _.round(
          currentYearAmount - previousYearAmount,
          2
        );
        const amountVariationPourcent = _.round(
          ((currentYearAmount - previousYearAmount) / previousYearAmount) *
          100.0,
          2
        );

        const quantity = props.negateValues
          ? edges[j].node.qty
          : -edges[j].node.qty;

        const currentYearQuantity = currentYearStr === year ? quantity : 0;
        const previousYearQuantity = previousYearStr === year ? quantity : 0;

        const quantityVariation = _.round(
          currentYearQuantity - previousYearQuantity,
          2
        );
        const quantityVariationPourcent = _.round(
          ((currentYearQuantity - previousYearQuantity) / previousYearQuantity) *
          100.0,
          2
        );

        const item = {
          ...edges[j].node,
          amount,
          currentYearQuantity,
          previousYearQuantity,
          quantityVariation,
          quantityVariationPourcent,
          currentYearAmount,
          previousYearAmount,
          amountVariation,
          amountVariationPourcent,
          period: key2
        };

        data.push(item);
      }
    }

    let dataAlternate = [];
    if (props.edgesAlternate) {
      for (let j = 0, lenj = props.edgesAlternate.length; j < lenj; j++) {
        // console.log("#" + j + " -", props.edgesAlternate[j].node);

        let tmpDate = new Date(fixDateFromDataBase(props.edgesAlternate[j].node.dateOperation));
        let key = "";
        // let keyYear = tmpDate.getFullYear().toString();
        let key2 = "";

        switch (typePeriode) {
          case "Q":
            key = tmpDate.getFullYear().toString() + "-";
            switch (tmpDate.getMonth() + 1) {
              case 1:
              case 2:
              case 3:
                key = key + "Q1";
                key2 = "Q1";
                break;

              case 4:
              case 5:
              case 6:
                key = key + "Q2";
                key2 = "Q2";
                break;

              case 7:
              case 8:
              case 9:
                key = key + "Q3";
                key2 = "Q3";
                break;

              case 10:
              case 11:
              case 12:
                key = key + "Q4";
                key2 = "Q4";
                break;

              default:
                break;
            }
            break;

          case "S":
            key = tmpDate.getFullYear().toString() + "-";
            switch (tmpDate.getMonth() + 1) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
                key = key + "S1";
                key2 = "S1";
                break;

              case 7:
              case 8:
              case 9:
              case 10:
              case 11:
              case 12:
                key = key + "S2";
                key2 = "S2";
                break;

              default:
                break;
            }
            break;

          case "N":
            key = tmpDate.getFullYear().toString() + "-";
            switch (tmpDate.getMonth() + 1) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
              case 8:
              case 9:
                key = key + "N1";
                key2 = "N1";
                break;

              case 10:
              case 11:
              case 12:
                key = key + "N2";
                key2 = "N2";
                break;

              default:
                break;
            }
            break;

          case "Y":
            key = tmpDate.getFullYear().toString();
            key2 = "Y";
            break;

          case "M":
          default:
            key =
              tmpDate.getFullYear().toString() +
              "-" +
              ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);

            key2 = ("0" + (tmpDate.getMonth() + 1).toString()).slice(-2);
            break;
        }

        // // Periode
        // let tmpValue;
        // let negateValues = props.negateValues;

        // if (
        //   props.splitAmountsByCategory &&
        //   props.edgesAlternate[j].node.category.categoryFamily.reportCost
        // ) {
        //   //negateValues = !negateValues;
        //   tmpValue = mapPeriodeNegative.get(key);
        // } else tmpValue = mapPeriode.get(key);

        // if (tmpValue === undefined) tmpValue = 0.0;

        // const amount = props.edgesAlternate[j].node.amount;

        // tmpValue = _.round(tmpValue + (negateValues ? amount * -1 : amount), 2);

        // if (
        //   props.splitAmountsByCategory &&
        //   props.edgesAlternate[j].node.category.categoryFamily.reportCost
        // )
        //   mapPeriodeNegative.set(key, tmpValue);
        // else mapPeriode.set(key, tmpValue);


        // build table data item
        // console.log("341 - filterPeriod=", filterPeriod);
        // console.log("342 - key2=", key2);
        if (filterPeriod === key2 || typePeriode === "Y") {
          const amount = props.negateValues
            ? -props.edgesAlternate[j].node.amount
            : props.edgesAlternate[j].node.amount;

          let year = tmpDate.getFullYear().toString();
          const currentYearAmount = currentYearStr === year ? amount : 0;
          const previousYearAmount = previousYearStr === year ? amount : 0;
          const amountVariation = _.round(
            currentYearAmount - previousYearAmount,
            2
          );
          const amountVariationPourcent = _.round(
            ((currentYearAmount - previousYearAmount) / previousYearAmount) *
            100.0,
            2
          );

          const quantity = props.negateValues
            ? props.edgesAlternate[j].node.qty
            : -props.edgesAlternate[j].node.qty;

          const currentYearQuantity = currentYearStr === year ? quantity : 0;
          const previousYearQuantity = previousYearStr === year ? quantity : 0;

          const quantityVariation = _.round(
            currentYearQuantity - previousYearQuantity,
            2
          );
          const quantityVariationPourcent = _.round(
            ((currentYearQuantity - previousYearQuantity) / previousYearQuantity) *
            100.0,
            2
          );

          const item = {
            ...props.edgesAlternate[j].node,
            amount,
            currentYearQuantity,
            previousYearQuantity,
            quantityVariation,
            quantityVariationPourcent,
            currentYearAmount,
            previousYearAmount,
            amountVariation,
            amountVariationPourcent,
            period: key2
          };

          // console.log("369 - Add item=", item);
          dataAlternate.push(item);
        }
      }
    }

    console.log("mapPeriode", mapPeriode);
    // console.log("mapPeriodeCategory", mapPeriodeCategory);

    let sourcePreviousYearData = {};
    let sourceCurrentYearData = {};

    let sourcePreviousYearDataNegative = {};
    let sourceCurrentYearDataNegative = {};

    let sourcePreviousYearCount = {};
    let sourceCurrentYearCount = {};

    let sourcePreviousYearCountNegative = {};
    let sourceCurrentYearCountNegative = {};

    let tmpCumul = 0.0;
    let tmpCount = 0.0;

    switch (typePeriode) {
      case "Q":
        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q1") && mapPeriode.get(currentYear - 1 + "-Q1").value;
        if (tmpCumul === undefined) {
          tmpCumul = 0.0;
          tmpCount = 0;
        }
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q2") && mapPeriode.get(currentYear - 1 + "-Q2").value;
        if (tmpCumul === undefined) {
          tmpCumul = 0.0;
          tmpCount = 0;
        }
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q3") && mapPeriode.get(currentYear - 1 + "-Q3").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-Q4") && mapPeriode.get(currentYear - 1 + "-Q4").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q1") && mapPeriode.get(currentYear + "-Q1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q2") && mapPeriode.get(currentYear + "-Q2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q3") && mapPeriode.get(currentYear + "-Q3").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-Q4") && mapPeriode.get(currentYear + "-Q4").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        //PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q1") && mapPeriodeNegative.get(currentYear - 1 + "-Q1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q2") && mapPeriodeNegative.get(currentYear - 1 + "-Q2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q3") && mapPeriodeNegative.get(currentYear - 1 + "-Q3").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-Q4") && mapPeriodeNegative.get(currentYear - 1 + "-Q4").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q1") && mapPeriodeNegative.get(currentYear + "-Q1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q2") && mapPeriodeNegative.get(currentYear + "-Q2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q3") && mapPeriodeNegative.get(currentYear + "-Q3").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-Q4") && mapPeriodeNegative.get(currentYear + "-Q4").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;

      case "S":
        tmpCumul = mapPeriode.get(currentYear - 1 + "-S1") && mapPeriode.get(currentYear - 1 + "-S1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-S2") && mapPeriode.get(currentYear - 1 + "-S2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-S1") && mapPeriode.get(currentYear + "-S1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-S2") && mapPeriode.get(currentYear + "-S2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        //PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-S1") && mapPeriodeNegative.get(currentYear - 1 + "-S1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-S2") && mapPeriodeNegative.get(currentYear - 1 + "-S2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-S1") && mapPeriodeNegative.get(currentYear + "-S1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-S2") && mapPeriodeNegative.get(currentYear + "-S2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" }) +
          "/" +
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;

      case "N":
        tmpCumul = mapPeriode.get(currentYear - 1 + "-N1") && mapPeriode.get(currentYear - 1 + "-N1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-N2") && mapPeriode.get(currentYear - 1 + "-N2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-N1") && mapPeriode.get(currentYear + "-N1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-N2") && mapPeriode.get(currentYear + "-N2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        //PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-N1") && mapPeriodeNegative.get(currentYear - 1 + "-N1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-N2") && mapPeriodeNegative.get(currentYear - 1 + "-N2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-N1") && mapPeriodeNegative.get(currentYear + "-N1").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" }) +
          "/" +
          intl.formatMessage({ id: "ids_february" }) +
          "/" +
          intl.formatMessage({ id: "ids_march" }) +
          "/" +
          intl.formatMessage({ id: "ids_april" }) +
          "/" +
          intl.formatMessage({ id: "ids_may" }) +
          "/" +
          intl.formatMessage({ id: "ids_june" }) +
          "/" +
          intl.formatMessage({ id: "ids_july" }) +
          "/" +
          intl.formatMessage({ id: "ids_august" }) +
          "/" +
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-N2") && mapPeriodeNegative.get(currentYear + "-N2").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_october" }) +
          "/" +
          intl.formatMessage({ id: "ids_november" }) +
          "/" +
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;

      case "Y":
        tmpCumul = mapPeriode.get((currentYear - 1).toString()) && mapPeriode.get((currentYear - 1).toString()).value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear.toString()) && mapPeriode.get(currentYear.toString()).value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get((currentYear - 1).toString()) && mapPeriodeNegative.get((currentYear - 1).toString()).value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear.toString()) && mapPeriodeNegative.get(currentYear.toString()).value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_year" })
        ] = tmpCumul;
        break;

      case "M":
      default:
        tmpCumul = mapPeriode.get(currentYear - 1 + "-01") && mapPeriode.get(currentYear - 1 + "-01").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-02") && mapPeriode.get(currentYear - 1 + "-02").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-03") && mapPeriode.get(currentYear - 1 + "-03").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-04") && mapPeriode.get(currentYear - 1 + "-04").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-05") && mapPeriode.get(currentYear - 1 + "-05").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_may" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-06") && mapPeriode.get(currentYear - 1 + "-06").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-07") && mapPeriode.get(currentYear - 1 + "-07").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-08") && mapPeriode.get(currentYear - 1 + "-08").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-09") && mapPeriode.get(currentYear - 1 + "-09").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-10") && mapPeriode.get(currentYear - 1 + "-10").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-11") && mapPeriode.get(currentYear - 1 + "-11").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear - 1 + "-12") && mapPeriode.get(currentYear - 1 + "-12").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearData[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-01") && mapPeriode.get(currentYear + "-01").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-02") && mapPeriode.get(currentYear + "-02").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-03") && mapPeriode.get(currentYear + "-03").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-04") && mapPeriode.get(currentYear + "-04").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-05") && mapPeriode.get(currentYear + "-05").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[intl.formatMessage({ id: "ids_may" })] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-06") && mapPeriode.get(currentYear + "-06").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-07") && mapPeriode.get(currentYear + "-07").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-08") && mapPeriode.get(currentYear + "-08").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-09") && mapPeriode.get(currentYear + "-09").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-10") && mapPeriode.get(currentYear + "-10").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-11") && mapPeriode.get(currentYear + "-11").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriode.get(currentYear + "-12") && mapPeriode.get(currentYear + "-12").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearData[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        // PeriodNegative
        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-01") && mapPeriodeNegative.get(currentYear - 1 + "-01").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-02") && mapPeriodeNegative.get(currentYear - 1 + "-02").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-03") && mapPeriodeNegative.get(currentYear - 1 + "-03").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-04") && mapPeriodeNegative.get(currentYear - 1 + "-04").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-05") && mapPeriodeNegative.get(currentYear - 1 + "-05").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_may" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-06") && mapPeriodeNegative.get(currentYear - 1 + "-06").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-07") && mapPeriodeNegative.get(currentYear - 1 + "-07").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-08") && mapPeriodeNegative.get(currentYear - 1 + "-08").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-09") && mapPeriodeNegative.get(currentYear - 1 + "-09").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-10") && mapPeriodeNegative.get(currentYear - 1 + "-10").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-11") && mapPeriodeNegative.get(currentYear - 1 + "-11").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear - 1 + "-12") && mapPeriodeNegative.get(currentYear - 1 + "-12").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourcePreviousYearDataNegative[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-01") && mapPeriodeNegative.get(currentYear + "-01").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_january" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-02") && mapPeriodeNegative.get(currentYear + "-02").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_february" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-03") && mapPeriodeNegative.get(currentYear + "-03").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_march" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-04") && mapPeriodeNegative.get(currentYear + "-04").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_april" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-05") && mapPeriodeNegative.get(currentYear + "-05").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_may" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-06") && mapPeriodeNegative.get(currentYear + "-06").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_june" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-07") && mapPeriodeNegative.get(currentYear + "-07").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_july" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-08") && mapPeriodeNegative.get(currentYear + "-08").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_august" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-09") && mapPeriodeNegative.get(currentYear + "-09").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_september" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-10") && mapPeriodeNegative.get(currentYear + "-10").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_october" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-11") && mapPeriodeNegative.get(currentYear + "-11").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_november" })
        ] = tmpCumul;

        tmpCumul = mapPeriodeNegative.get(currentYear + "-12") && mapPeriodeNegative.get(currentYear + "-12").value;
        if (tmpCumul === undefined) tmpCumul = 0.0;
        sourceCurrentYearDataNegative[
          intl.formatMessage({ id: "ids_december" })
        ] = tmpCumul;
        break;
    }

    // console.log("Source current=", sourceCurrentYearData);
    // console.log("Negative current=", sourceCurrentYearDataNegative);

    // console.log("Source previous=", sourcePreviousYearData);
    // console.log("Negative previous=", sourcePreviousYearDataNegative);

    // console.log("tabData=", data);

    // console.log("1004 - dataAlternate=", dataAlternate);
    return {
      //periodCategory: mapPeriodeCategory,
      previousYearData: sourcePreviousYearData,
      currentYearData: sourceCurrentYearData,
      previousYearDataNegative: sourcePreviousYearDataNegative,
      currentYearDataNegative: sourceCurrentYearDataNegative,
      tabData: data,
      tabDataAlternate: dataAlternate
    };
  }
};

export default ChartsDataCompute;
